module.exports = __webpack_public_path__ + "static/media/comment-lines.7c6a9cb8.svg";